var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportingApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_761)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0834 22.95L6.1667 15.7167C4.60003 14.8167 4.60003 13.3334 6.1667 12.4334L19.0834 5.19999C19.3667 5.06666 19.6833 5 20 5C20.3167 5 20.6333 5.06666 20.9167 5.19999L33.8333 12.4334C35.4 13.3334 35.4 14.8167 33.8333 15.7167L20.9167 22.95C20.6333 23.0834 20.3167 23.15 20 23.15C19.6833 23.15 19.3667 23.0834 19.0834 22.95Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1667 22.8L33.8333 24.2833C35.4 25.1833 35.4 26.6666 33.8333 27.5666L20.9167 34.8C20.6333 34.9333 20.3167 35 20 35C19.6833 35 19.3667 34.9333 19.0834 34.8L6.1667 27.5666C4.60003 26.6666 4.60003 25.1833 6.1667 24.2833L8.81664 22.8",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_761"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportingApps);
export default __webpack_public_path__ + "static/media/supporting-apps.4f52ed82508da7d2fc7a6c692309e13b.svg";
export { ForwardRef as ReactComponent };